import { featuresFaq } from '../../data/support/featuresFaq';
import { gettingStartedFaq } from '../../data/support/gettingStartedFaq';
import { paymentFaq } from '../../data/support/paymentFaq';
import { technicalFaq } from '../../data/support/technicalFaq';
import { worksheetFaq } from '../../data/support/worksheetFaq';

export const ALL_SUPPORT_FAQS = [...gettingStartedFaq, ...featuresFaq, ...worksheetFaq, ...paymentFaq, ...technicalFaq];

const CATEGORY_BY_PREFIX = [
  { prefix: 'getting-started', label: '처음 시작하기', to: '/support/getting-started' },
  { prefix: 'features', label: '기능별 사용법', to: '/support/features' },
  { prefix: 'worksheet', label: '학습지 만들기', to: '/support/worksheet' },
  { prefix: 'payment', label: '결제·이용권', to: '/support/payment' },
  { prefix: 'technical', label: '로그인·오류 해결', to: '/support/technical' },
];

export const findSupportFaq = (id) => ALL_SUPPORT_FAQS.find((faq) => faq.id === id) || null;

export const getFaqCategory = (id = '') =>
  CATEGORY_BY_PREFIX.find((category) => String(id).startsWith(`${category.prefix}-`)) || null;

// 데이터에 적힌 관련 질문을 먼저 쓰고, 모자라면 태그가 겹치는 질문으로 3개까지 채운다.
export const getRelatedFaqs = (faq, limit = 3) => {
  if (!faq) return [];
  const picked = [];
  const add = (item) => {
    if (item && item.id !== faq.id && !picked.some((p) => p.id === item.id)) picked.push(item);
  };
  (faq.relatedFaqs || []).forEach((id) => add(findSupportFaq(id)));
  const tags = faq.tags || [];
  ALL_SUPPORT_FAQS
    .filter((item) => (item.tags || []).some((tag) => tags.includes(tag)))
    .forEach(add);
  return picked.slice(0, limit);
};
